export default {
  label: 'Cobrar a taxa de serviço nos pedidos à mesa',
  description: 'Os pedidos à mesa não pagam taxa de serviço, a menos que esta opção esteja ativa.',
  no_fee: 'O seu restaurante não cobra taxa de serviço, por isso os pedidos à mesa também não pagam nenhuma.',
  partner_default_on: 'Predefinição do parceiro: ativado',
  partner_default_off: 'Predefinição do parceiro: desativado',
  toasts: {
    on: 'Os pedidos à mesa passam a pagar a taxa de serviço',
    off: 'Os pedidos à mesa deixam de pagar taxa de serviço',
    error: 'Não foi guardado. Tente novamente.',
  },
};
